import type { ShopDto, UpdateOneShopPreferencesDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdatePortalBasics(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation(
    "patch",
    "/shops/{shopId}/preferences",
    {
      invalidate: invalidateShop,
      mapVariables: (data: UpdateOneShopPreferencesDto) => ({
        params: { path: { shopId: shop.id } },
        body: data,
      }),
    },
  );
}
